(function () {
  /**
   * BatchGeo's ruler Drawing Manager tool. It allows you to click and drag to
   * draw a line that measures the distance between two points
   */
  var BatchGeoDrawingManagerRuler = $.extend(
    true,
    {},
    window.BatchGeoDrawingManagerBaseTool,
    {
      button: {
        class: "drawing-manager-button drawing-manager-button-ruler",
        title: "Measuring tool",
        order: 5,
        icon: "ruler",
        mode: "ruler",
      },

      // See BaseTool for docs on this method
      buildShape: function () {
        return new google.maps.Polyline(
          $.extend(
            {
              map: this.drawingManager.settings.map,
              path: [this.startPosition, this.startPosition],
              editable: false,
              draggable: false,
              strokeColor: "#4285F4",
              strokeWeight: 5,
              zIndex: 999,
            },
            this.options,
          ),
        );
      },

      // See BaseTool for docs on this method
      resizeShapeHandler: function (event) {
        var drawingManager = this.drawingManager;

        this.shape.setOptions({
          path: [this.startPosition, drawingManager.fromEventToLatLng(event)],
        });

        var distance = drawingManager.distanceBetweenTwoLatLng(
          this.startPosition,
          drawingManager.fromEventToLatLng(event),
        );

        this.label.setPosition(
          drawingManager.fromEventToLatLng(event),
          "ruler",
        );
        this.label.render(
          distance.toFixed(2) + drawingManager.getDistanceScale(),
        );
      },

      // Returns false because it doesn't need to do anything at all.
      selectionHandler: function () {
        return false;
      },
    },
  );

  window.BatchGeoDrawingManagerRuler = BatchGeoDrawingManagerRuler;
})(window);
